import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Pages
import HomePage from "./pages/HomePage";
import GetPaidPage from "./pages/GetPaidPage";
import ApplyPage from "./pages/ApplyPage";
import BookMeetingPage from "./pages/BookMeetingPage";
import SwiftAiPage from "./pages/SwiftAiPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/get-paid" element={<GetPaidPage />} />
          <Route path="/apply" element={<ApplyPage />} />
          <Route path="/book-meeting" element={<BookMeetingPage />} />
          <Route path="/swift-ai-april" element={<SwiftAiPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-right" 
        toastOptions={{
          style: {
            background: '#121212',
            border: '1px solid rgba(89, 216, 98, 0.3)',
            color: '#ffffff',
          },
        }}
      />
    </div>
  );
}

export default App;
